import { Box, Typography, styled } from "@mui/material";
import colors from "../../theme/Colours";

export const HeadingContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  marginTop: "10px",
  paddingTop: "25px",
  backgroundColor: colors.productBackground,
}));

export const HeadingTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "DM Sans, sans-serif",
  fontWeight: 400,
  fontSize: "60px",
  lineHeight: "100%",
  letterSpacing: "0px",
  textAlign: "center",
  color: colors.homePageRed,

  [theme.breakpoints.down("md")]: {
    fontSize: "48px",
  },

  [theme.breakpoints.down("sm")]: {
    fontSize: "32px",
  },
})) as typeof Typography;

export const HeadingSubtitle = styled(Typography)(() => ({
  fontFamily: "Plus Jakarta Sans, sans-serif",
  fontWeight: 300,
  fontSize: "16px",
  color: colors.clickTextBlack,
}));
